import { Inject, Injectable } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- app-boundary-backlog
import { UserHelper } from 'src/app/providers/helpers/user-helper.service';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- app-boundary-backlog
import { ArticleService } from 'src/app/providers/model-services/article.service';
import { IInventoryHelper } from 'src/packages/mitsBasics';
import { BufferstockModel } from '../models';
import { BufferstockService } from '../providers';
import { BufferstockInventoryService } from '../providers/buffertock-inventory.service';
import { StockMovementService } from '../providers';
import { StockObjectService } from '../providers/stockObject.service';
import { IMovementQueue, MOVEMENT_QUEUE } from '../providers/movement-queue.token';
import BasicStockInventoryHelperService from './basic-stock-inventory-helper';

/**
 * Verbuchung auf den Lägern
 */
@Injectable({
  providedIn: 'root',
})
export class StockInventoryHelperService
  extends BasicStockInventoryHelperService<BufferstockModel>
  implements IInventoryHelper
{
  constructor(
    protected stockService: BufferstockService,
    protected stockInventoryService: BufferstockInventoryService,
    protected stockMovementService: StockMovementService,
    protected articleService: ArticleService,
    protected readonly stockObjService: StockObjectService,
    protected userHelper: UserHelper,
    @Inject(MOVEMENT_QUEUE) public readonly queueService: IMovementQueue
  ) {
    super(
      articleService,
      stockInventoryService,
      stockService,
      stockMovementService,
      stockObjService,
      userHelper,
      queueService
    );
  }
}
